import { useContext } from 'react';
import { Session } from './types/Session';
import { SessionContext } from './SessionContextProvider';

export const useSessionContext = (): Session => useContext(SessionContext);
